import xhr from './xhr';

const getInvitesByShiftId = async (shiftId, isRecurring) => {
	try {
		const { data } = await xhr.request(
			'GET',
			`/caregivers-invite/shift/${shiftId}${isRecurring ? '?isRecurring=true' : ''}`,
			{}
		);
		return data;
	} catch (error) {
		return null;
	}
};

const InviteCaregiverUtils = {
	getInvitesByShiftId
};

export default InviteCaregiverUtils;
